import React from 'react';

export default function StatusIconActive({ width, height, color }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 21"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Source-Slideout-Panel-View"
          transform="translate(-1214.000000, -191.000000)"
          fill={color}
        >
          <path
            d="M1227.70495,199.247374 L1223.00212,199.247374 C1222.58787,199.247374 1222.25079,198.910293 1222.25079,198.496048 L1222.25079,191.750474 C1222.25079,191.019463 1221.31671,190.722991 1220.89028,191.315934 L1214.14055,202.187742 C1213.78723,202.683206 1214.14055,203.373608 1214.74973,203.373608 L1219.4405,203.373608 C1219.85475,203.373608 1220.19183,203.710689 1220.19183,204.124935 L1220.19183,210.874666 C1220.19183,211.605677 1221.12591,211.902149 1221.55234,211.309206 L1228.31829,200.43324 C1228.66756,199.937776 1228.31423,199.247374 1227.70505,199.247374 L1227.70495,199.247374 Z"
            id="Active-Status-Icon"
          ></path>
        </g>
      </g>
    </svg>
  );
}

StatusIconActive.defaultProps = {
  width: '15px',
  height: '20px',
  color: '#4AD496',
};
